// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* shared.css - Common styles for both web and Capacitor (EXACT copy, no changes) */

/* Body and Container Styles */
body { 
  font-family: 'Inter', Arial, sans-serif; 
  background: #f9fafb; 
  color: #222; 
  margin: 0; 
}
.container { 
  max-width: 600px; 
  margin: 0 auto; 
  padding: 32px 16px; 
}

.button-container { 
  display: flex; /* Use flexbox layout */
  justify-content: center; /* Center the buttons horizontally */
  gap: 1rem; /* Space between buttons */
  margin-top: 1.5rem; /* Space above the button container */
}

/* Header Styles */
header { 
  text-align: center; 
  margin-bottom: 2rem; 
}
h1 { 
  font-size: 2.2rem; 
  font-weight: 700; 
  margin: 0 0 0 0; /* Remove margin below heading */ 
}

/* Game Stats - Desktop Layout (Default) */
.game-stats {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  padding: 0.7rem 1.2rem;
  min-width: 80px;
  border: 1px solid #e5e7eb;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
}

.stat-label {
  font-size: 0.85rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 1px;
}

#timer.danger { color: #ef4444; }
#timer.warning { color: #f59e42; }

.timer-stat {
  transform: none !important;
  transition: none !important;
  animation: none !important;
}

/* Floating bonus indicator - Candy Crush Sparkle Style */
.floating-bonus-indicator {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background: linear-gradient(45deg, #facc15, #fbbf24, #f59e0b, #d97706, #facc15);
  background-size: 200% 200%;
  color: #1f2937;
  padding: 12px 24px;
  border-radius: 20px;
  font-size: 2.4rem;
  font-weight: bold;
  box-shadow: 0 0 30px rgba(250, 204, 21, 0.8), 0 8px 24px rgba(250, 204, 21, 0.4);
  z-index: 1000;
  pointer-events: none;
  animation: float-down-fade-right 2.5s ease-out forwards, gradient-shift 2.5s ease-out;
  overflow: visible;
  width: auto;
  height: auto;
  display: inline-block;
  white-space: nowrap;
}

.floating-bonus-indicator::before,
.floating-bonus-indicator::after {
  content: "✨";
  position: absolute;
  font-size: 1.5rem;
  animation: sparkle 0.5s ease-in-out infinite alternate;
  z-index: 1001;
}

.floating-bonus-indicator::before {
  top: -10px;
  left: -10px;
  animation-delay: 0s;
}

.floating-bonus-indicator::after {
  bottom: -10px;
  right: -10px;
  animation-delay: 0.25s;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes sparkle {
  0% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes float-down-fade-right {
  0% {
    opacity: 0;
    transform: translateY(-50%) scale(0.8);
  }
  15% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  85% {
    opacity: 1;
    transform: translateY(50vh) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(70vh) scale(0.8);
  }
}

/* Progress Bar Styles */
.progress-container { 
  width: 100%; 
  background: #e5e7eb; 
  border-radius: 4px; 
  margin: 1.5rem 0 2rem 0; 
  height: 8px; 
  overflow: hidden; 
}
.progress-bar { 
  height: 100%; 
  background: #2563eb; 
  border-radius: 4px; 
  transition: width 0.3s; 
}

/* Question Styles */
.question-container {
  text-align: center;
  margin-bottom: 2rem;
  min-height: 40px; 
}

.question {
  display: inline-block;
  position: relative;
  font-size: 1.3rem;
  font-weight: 500;
}

/* Flag Options Styles */
.flag-options { 
  display: flex; 
  flex-direction: column; 
  gap: 1rem; 
}
.flag-option { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  cursor: pointer; 
  transition: transform 0.15s; 
  position: relative; 
  background: #fff; 
  border-radius: 10px; 
  box-shadow: 0 1px 6px rgba(0,0,0,0.06); 
  padding: 0.7rem 0.7rem 0.3rem 0.7rem; 
  border: 1.5px solid transparent; 
}
.flag-option:hover { 
  transform: translateY(-4px) scale(1.04); 
  box-shadow: 0 4px 16px rgba(37,99,235,0.08); 
}

.flag-img { 
  width: 90px; 
  height: 60px; 
  object-fit: cover; 
  border-radius: 6px; 
  border: 2.5px solid transparent; 
  background: #eee; 
  transition: border-color 0.2s, box-shadow 0.2s; 
}
.flag-img.correct { 
  border-color: #22c55e; 
  box-shadow: 0 0 0 4px #22c55e33; 
  animation: pulse-success 0.7s; 
}
.flag-img.incorrect { 
  border-color: #ef4444; 
  animation: shake 0.5s; 
}

/* Feedback Styles */
.feedback { 
  margin: 1.5rem 0 0.5rem 0; 
  text-align: center; 
  font-size: 1.2rem; 
  font-weight: 600; 
  min-height: 2rem; 
  color: #1e40af; 
}

/* Button Styles */
.button {
  background: #2563eb;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;
  margin: 8px;
  min-width: 120px;
}

.button:hover {
  background: #1d4ed8;
}

.button:active {
  background: #1e40af;
}

.button.success {
  background: #059669;
}

.button.success:hover {
  background: #047857;
}

.button.secondary {
  background: #6b7280;
}

.button.secondary:hover {
  background: #4b5563;
}

/* Difficulty Buttons Styles */
.difficulty-btn {
  padding: 0.5rem 1.2rem;
margin-bottom: 1.5rem;
margin-right: 0.5rem;
margin-left: 0.5rem;
  background: #f3f4f6;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  color: #222;
  transition: background 0.15s, color 0.15s;
}

.difficulty-btn.active {
  background: #2563eb;
  color: #fff;
}

/* Modal Overlay - Simplified and Fixed */
.modal { 
  position: fixed; 
  top: 0; 
  left: 0; 
  width: 100vw; 
  height: 100vh; 
  background: rgba(30, 41, 59, 0.5);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  z-index: 9999; 
  opacity: 0; 
  visibility: hidden; 
  transition: opacity 0.3s, visibility 0.3s; 
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}

.modal.active { 
  opacity: 1; 
  visibility: visible; 
}

/* Modal Content - Unified for all platforms */
.modal-content {
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(30, 41, 59, 0.18);
  border: 1px solid #e5e7eb;
  animation: modal-fade-in 0.4s cubic-bezier(.4,0,.2,1);
  font-family: 'Inter', Arial, sans-serif;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

/* Native app specific adjustments */
.modal.native-app {
  background: rgba(0, 0, 0, 0.6);
  padding: 10px;
}

.modal-content.native-content {
  max-width: 95%;
  max-height: 85vh;
}

@keyframes modal-fade-in {
  from { opacity: 0; transform: translateY(32px) scale(0.98);}
  to { opacity: 1; transform: translateY(0) scale(1);}
}

/* Modal Header */
.modal-header { 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* Modal Body - Scrollable content area */
.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 1.5rem;
  -webkit-overflow-scrolling: touch;
}

/* Close Button - Enhanced for mobile */
.modal-close { 
  background: none; 
  border: none; 
  font-size: 2rem; 
  cursor: pointer; 
  color: #64748b;
  transition: all 0.2s;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  flex-shrink: 0;
}

.modal-close:hover,
.modal-close:focus {
  background: #e0e7ef;
  color: #1e293b;
}

.modal-close:active {
  transform: scale(0.95);
  background: #d1d5db;
}

/* High Score Note */
.high-score-note {
  margin: 1rem 0;
  font-size: 0.9rem;
  font-style: italic;
  color: #666;
  text-align: center;
}

/* High Scores Container */
.high-scores-container {
  padding: 1rem 0;
}

/* High Scores Difficulty Groups */
.high-scores-difficulty-group {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e7ef;
}

.high-scores-difficulty-group:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.difficulty-group-header {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
}

/* High Scores Header */
.high-scores-header {
  display: flex;
  padding: 0.75rem 0 0.5rem 0;
  border-bottom: 2px solid #e5e7eb;
  font-weight: 600;
  color: #4b5563;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

/* High Scores List */
.high-scores-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.high-score-entry {
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
  font-size: 0.95rem;
  color: #4b5563;
  border-bottom: 1px dashed #f3f4f6;
}

.high-score-entry:last-child {
  border-bottom: none;
}

/* Column Layout */
.header-rank, .entry-position {
  flex: 0 0 15%;
  text-align: center;
}

.header-name, .entry-name {
  flex: 1;
  text-align: left;
  padding-right: 1rem;
  overflow-wrap: break-word;
}

.header-score, .entry-points {
  flex: 0 0 18%;
  text-align: center;
}

.header-accuracy, .entry-accuracy {
  flex: 0 0 20%;
  text-align: center;
}

.header-date, .entry-date {
  flex: 0 0 22%;
  text-align: center;
}

/* Modal States */
.modal-loading,
.modal-empty {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
}

.modal-loading {
  background: #f8f9fa;
  border-radius: 8px;
  margin: 1rem 0;
}

.modal-empty {
  background: #f0f9ff;
  border: 1px dashed #bae6fd;
  border-radius: 8px;
  margin: 1rem 0;
}

/* Modal Footer */
.modal-footer {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e0e7ef;
  background: #f9fafb;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.modal-footer .button {
  min-height: 44px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  transition: all 0.2s;
}

.modal-footer .button:active {
  transform: scale(0.98);
}

/* Game Over Flag Display Styles */
.game-over-flags-container {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
}

.flag-column {
  text-align: center;
}

.flag-column h3 {
  margin-bottom: 1rem;
}

.flag-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.flag-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flag-item img {
  width: 120px;
  height: 80px;
  object-fit: contain;
  border-radius: 6px;
}

.flag-item span {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #6b7280;
}

.empty-message {
  color: #6b7280;
}

/* Difficulty Selector */
.difficulty-selector {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

/* Centered Text Style */
.centered-text {
  text-align: center;
  margin-bottom: 2rem;
}

/* Toggle Switch */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
}

.toggle-switch {
  position: relative;
  width: 40px;
  height: 20px;
  display: inline-block;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  border-radius: 20px;
  transition: background-color 0.3s;
}

.switch-slider::before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggle-switch input:checked + .switch-slider {
  background-color: #2563eb;
}

.toggle-switch input:checked + .switch-slider::before {
  transform: translateX(20px);
}

.toggle-label {
  font-size: 1rem;
  color: #222;
}

/* Rotates emoji 45 degrees. Using this to turn a black square into a black diamond. */
.rotate-emoji {
  display: inline-block;
  transform: rotate(45deg);
  font-size: 1.25rem;
}

/* New High Score Banner */
.new-high-score-banner {
  background: linear-gradient(45deg, #ffd700, #ffed4e);
  color: #1a1a1a;
  text-align: center;
  padding: 15px;
  margin: 20px 0;
  border-radius: 10px;
  font-size: 1.5rem;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  position: relative;
  animation: celebrateGlowBounce 2s ease-in-out infinite;
}

.new-high-score-banner::after {
  content: "✨";
  font-size: 3rem;
  position: absolute;
  top: -10px;
  right: 10px;
  animation: sparkle 1s ease-in-out infinite alternate;
}

.new-high-score-banner span {
  display: inline-block;
  animation: textPop 0.5s ease-in-out infinite alternate;
}

@keyframes celebrateGlowBounce {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
    transform: scale(1) translateY(0);
  }
  50% {
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.6);
    transform: scale(1.02) translateY(-8px);
  }
}

@keyframes textPop {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

/* Leaderboard Banner */
.leaderboard-banner {
  background: linear-gradient(45deg, #f3f4f6, #e5e7eb);
  color: #374151;
  text-align: center;
  padding: 15px;
  margin: 20px 0;
  border-radius: 10px;
  font-size: 1.3rem;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: leaderboardGlow 2s ease-in-out infinite;
  border: 2px solid #d1d5db;
}

.leaderboard-banner::after {
  content: "🏆";
  position: absolute;
  top: -10px;
  right: 10px;
  animation: trophyBounce 1.5s ease-in-out infinite alternate;
}

.leaderboard-banner span {
  display: inline-block;
  animation: subtleTextPop 0.8s ease-in-out infinite alternate;
}

@keyframes leaderboardGlow {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transform: scale(1) translateY(0);
  }
  50% {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    transform: scale(1.01) translateY(-4px);
  }
}

@keyframes trophyBounce {
  0% {
    opacity: 0.6;
    transform: scale(0.9) rotate(-5deg);
  }
  100% {
    opacity: 1;
    transform: scale(1.1) rotate(5deg);
  }
}

@keyframes subtleTextPop {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.05);
  }
}

/* Tooltip Styles */
.tooltip-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ddd;
  color: #333;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
  cursor: pointer;
  position: relative;
  vertical-align: super;
}

.tooltip-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #333;
  color: #fff;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  min-width: 200px;
  max-width: 300px;
  z-index: 1000;
  white-space: normal;
  word-wrap: break-word;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #555;
}

/* Mobile responsive tooltip adjustments */
@media (max-width: 768px) {
  .tooltip-text {
    position: fixed;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 90vw;
    max-width: 350px;
    min-width: auto;
    font-size: 16px;
    padding: 16px;
    border-radius: 12px;
    z-index: 10000;
  }

  .tooltip-icon {
    width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
  }
}

/* Player Name Form */
.player-name-form {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.player-name-input {
  padding: 0.8rem 1.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1.5rem;
  width: 200px;
  margin-right: 0.5rem;
}

.submit-button {
  background: #2563eb; 
  color: #fff; 
  border: none; 
  padding: 0.8rem 1.5rem; 
  font-size: 1rem; 
  border-radius: 6px; 
  cursor: pointer; 
  transition: background 0.18s; 
  font-weight: 600; 
  box-shadow: 0 1px 4px rgba(0,0,0,0.04); 
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.submit-button:hover {
  background-color: #1e40af;
}



/* Info Button (replaces tooltip icon) */
.info-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ddd;
  color: #333;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  margin-left: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: bold;
}

.info-button:hover {
  background: #bbb;
  transform: scale(1.1);
}

.info-button:active {
  transform: scale(0.95);
}

/* Info Modal Styles */
.info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  box-sizing: border-box;
}

.info-modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modal-fade-in 0.3s ease-out;
}

.info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.info-modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #1e293b;
}

.info-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #64748b;
  padding: 4px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.info-modal-close:hover {
  background: #e0e7ef;
  color: #1e293b;
}

.info-modal-body {
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
}

.info-modal-body p {
  margin: 0 0 1rem 0;
  line-height: 1.6;
  color: #374151;
}

.info-modal-body p:last-child {
  margin-bottom: 0;
}

.info-modal-footer {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

/* Privacy Policy Modal Styles */
.privacy-policy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.privacy-policy-content {
  background: white;
  border-radius: 12px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.privacy-policy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.privacy-policy-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #1f2937;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s;
}

.close-button:hover {
  color: #374151;
}

.privacy-policy-body {
  padding: 24px;
  flex: 1;
  overflow-y: auto;
}

.privacy-policy-body h3 {
  color: #1f2937;
  margin-top: 24px;
  margin-bottom: 12px;
  font-size: 1.25rem;
}

.privacy-policy-body h4 {
  color: #374151;
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 1.1rem;
}

.privacy-policy-body h5 {
  color: #4b5563;
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 1rem;
}

.privacy-policy-body p {
  margin-bottom: 12px;
  line-height: 1.6;
  color: #4b5563;
}

.privacy-policy-body ul {
  margin-bottom: 16px;
  padding-left: 20px;
}

.privacy-policy-body li {
  margin-bottom: 6px;
  line-height: 1.5;
  color: #4b5563;
}

.privacy-policy-body a {
  color: #2563eb;
  text-decoration: none;
}

.privacy-policy-body a:hover {
  text-decoration: underline;
}

.privacy-policy-footer {
  padding: 16px 24px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

/* Web Availability Text - Only shown in native app, positioned at bottom left */
.web-availability-text {
  position: fixed;
  bottom: 50px;
  left: 20px;
  background: #ffffff;
  color: #000;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: normal;
  white-space: nowrap;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Web Availability Button - Clickable styling */
.web-availability-button {
  cursor: pointer;
  transition: background-color 0.2s;
}

.web-availability-button:hover {
  background: #f3f4f6;
}

/* Privacy Policy Button - Small and Subtle */
.privacy-policy-button {
  position: fixed;
  bottom: 50px;
  right: 20px;
  background: #f3f4f6;
  color: #000;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  transition: background-color 0.2s;
  z-index: 100;
  min-width: auto;
  margin: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.privacy-policy-button:hover {
  background: #e5e7eb;
}

/* Native app adjustments for positioning */
.native-app .web-availability-text {
  bottom: 60px;
  left: 30px;
}

.native-app .privacy-policy-button {
  bottom: 60px;
  right: 30px;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .web-availability-text {
    bottom: 45px;
    left: 15px;
    font-size: 11px;
    padding: 6px 10px;
  }
  
  .privacy-policy-button {
    bottom: 45px;
    right: 15px;
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* Very small screens */
@media (max-width: 480px) {
  .web-availability-text {
    bottom: 40px;
    left: 10px;
    font-size: 10px;
    padding: 5px 8px;
  }
  
  .privacy-policy-button {
    bottom: 40px;
    right: 10px;
    padding: 5px 8px;
    font-size: 10px;
  }
}

/* High Scores Tabs */
.high-scores-tabs {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 0;
  margin: 0;
}

.tab-button {
  flex: 1;
  padding: 1rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.2s ease;
  text-align: center;
}

.tab-button:hover {
  background: #f3f4f6;
  color: #374151;
}

.tab-button.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  background: #eff6ff;
}

.tab-button.active:hover {
  background: #dbeafe;
}

/* Mobile responsive tabs */
@media (max-width: 768px) {
  .tab-button {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }
}

/* Native app adjustments for tabs */
.native-app .high-scores-tabs {
  border-bottom: 1px solid #d1d5db;
}

.native-app .tab-button {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* Personal Best Banner */
.personal-best-banner {
  background: linear-gradient(45deg, #ffd700, #ffed4e);
  color: #1a1a1a;
  text-align: center;
  padding: 15px;
  margin: 20px 0;
  border-radius: 10px;
  font-size: 1.5rem;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  position: relative;
  animation: celebrateGlowBounce 2s ease-in-out infinite;
}

.personal-best-banner::after {
  content: "✨";
  font-size: 3rem;
  position: absolute;
  top: -10px;
  right: 10px;
  animation: sparkle 1s ease-in-out infinite alternate;
}

.personal-best-banner span {
  display: inline-block;
  animation: textPop 0.5s ease-in-out infinite alternate;
}

/* Personal Best Banner Styles for 2nd, 3rd, 4th place - gray like leaderboard */
.personal-best-banner.secondary {
  background: linear-gradient(45deg, #f3f4f6, #e5e7eb);
  color: #374151;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  animation: leaderboardGlow 2s ease-in-out infinite;
  border: 2px solid #d1d5db;
}

.personal-best-banner.secondary::after {
  content: "✨";
  font-size: 3rem;
  position: absolute;
  top: -10px;
  right: 10px;
  animation: sparkle 1s ease-in-out infinite alternate;
}

.personal-best-banner.secondary span {
  animation: subtleTextPop 0.8s ease-in-out infinite alternate;
}

/* Info Modal Styles */
.info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  box-sizing: border-box;
}

/* Confirmation Dialog Styles */
.confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-dialog {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.confirmation-dialog h3 {
  margin: 0 0 16px 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.confirmation-dialog p {
  margin: 0 0 24px 0;
  color: #4b5563;
  line-height: 1.5;
  font-size: 1rem;
}

.confirmation-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.confirmation-buttons .button {
  min-width: 120px;
  padding: 10px 16px;
  font-size: 0.9rem;
}

.confirmation-buttons .button.secondary {
  background: #6b7280;
  color: white;
}

.confirmation-buttons .button.secondary:hover {
  background: #4b5563;
}

/* Mobile responsiveness for confirmation dialog */
@media (max-width: 480px) {
  .confirmation-dialog {
    margin: 20px;
    padding: 20px;
  }
  
  .confirmation-buttons {
    flex-direction: column;
  }
  
  .confirmation-buttons .button {
    width: 100%;
    min-width: auto;
  }
}

/* Data Disclosure Modal Styles */
.data-disclosure-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 10002;
  padding: 20px;
  box-sizing: border-box;
}

.data-disclosure-modal {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
  margin-bottom: 20px;
}

.data-disclosure-modal h3 {
  margin: 0 0 16px 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.data-disclosure-modal p {
  margin: 0 0 24px 0;
  color: #4b5563;
  line-height: 1.5;
  font-size: 1rem;
}

.data-disclosure-modal .button {
  min-width: 120px;
  padding: 10px 24px;
  font-size: 1rem;
}

.data-disclosure-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.data-disclosure-buttons .button {
  min-width: 120px;
  padding: 10px 16px;
  font-size: 0.9rem;
}

.data-disclosure-buttons .button.secondary {
  background: #f3f4f6;
  color: #000000;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.data-disclosure-buttons .button.secondary:hover {
  background: #e5e7eb;
}

.data-disclosure-buttons .button.success {
  background: #2563eb;
}

/* Mobile responsiveness for data disclosure modal */
@media (max-width: 480px) {
  .data-disclosure-modal {
    margin: 20px;
    padding: 20px;
  }
  
  .data-disclosure-buttons {
    flex-direction: column;
  }
  
  .data-disclosure-buttons .button {
    width: 100%;
    min-width: auto;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/shared.css"],"names":[],"mappings":"AAAA,mFAAmF;;AAEnF,8BAA8B;AAC9B;EACE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,uBAAuB,EAAE,oCAAoC;EAC7D,SAAS,EAAE,0BAA0B;EACrC,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAE,gCAAgC;AACnD;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gBAAgB,cAAc,EAAE;AAChC,iBAAiB,cAAc,EAAE;;AAEjC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,+EAA+E;EAC/E,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gFAAgF;EAChF,aAAa;EACb,oBAAoB;EACpB,qFAAqF;EACrF,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB,qBAAqB;AACrB,oBAAoB;AACpB,mBAAmB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;EACzB,qDAAqD;EACrD,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,CAAC;EAC3D,KAAK,UAAU,EAAE,iCAAiC,CAAC;AACrD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sFAAsF;AACtF;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,oDAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE;IACE,6CAA6C;IAC7C,iCAAiC;EACnC;EACA;IACE,6CAA6C;IAC7C,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,uBAAuB;AACvB;EACE,oDAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE;IACE,yCAAyC;IACzC,iCAAiC;EACnC;EACA;IACE,0CAA0C;IAC1C,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,oDAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA,gFAAgF;AAChF;EACE,oDAAoD;EACpD,cAAc;EACd,yCAAyC;EACzC,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* shared.css - Common styles for both web and Capacitor (EXACT copy, no changes) */\n\n/* Body and Container Styles */\nbody { \n  font-family: 'Inter', Arial, sans-serif; \n  background: #f9fafb; \n  color: #222; \n  margin: 0; \n}\n.container { \n  max-width: 600px; \n  margin: 0 auto; \n  padding: 32px 16px; \n}\n\n.button-container { \n  display: flex; /* Use flexbox layout */\n  justify-content: center; /* Center the buttons horizontally */\n  gap: 1rem; /* Space between buttons */\n  margin-top: 1.5rem; /* Space above the button container */\n}\n\n/* Header Styles */\nheader { \n  text-align: center; \n  margin-bottom: 2rem; \n}\nh1 { \n  font-size: 2.2rem; \n  font-weight: 700; \n  margin: 0 0 0 0; /* Remove margin below heading */ \n}\n\n/* Game Stats - Desktop Layout (Default) */\n.game-stats {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n  padding: 0.7rem 1.2rem;\n  min-width: 80px;\n  border: 1px solid #e5e7eb;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n#timer.danger { color: #ef4444; }\n#timer.warning { color: #f59e42; }\n\n.timer-stat {\n  transform: none !important;\n  transition: none !important;\n  animation: none !important;\n}\n\n/* Floating bonus indicator - Candy Crush Sparkle Style */\n.floating-bonus-indicator {\n  position: fixed;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  background: linear-gradient(45deg, #facc15, #fbbf24, #f59e0b, #d97706, #facc15);\n  background-size: 200% 200%;\n  color: #1f2937;\n  padding: 12px 24px;\n  border-radius: 20px;\n  font-size: 2.4rem;\n  font-weight: bold;\n  box-shadow: 0 0 30px rgba(250, 204, 21, 0.8), 0 8px 24px rgba(250, 204, 21, 0.4);\n  z-index: 1000;\n  pointer-events: none;\n  animation: float-down-fade-right 2.5s ease-out forwards, gradient-shift 2.5s ease-out;\n  overflow: visible;\n  width: auto;\n  height: auto;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.floating-bonus-indicator::before,\n.floating-bonus-indicator::after {\n  content: \"✨\";\n  position: absolute;\n  font-size: 1.5rem;\n  animation: sparkle 0.5s ease-in-out infinite alternate;\n  z-index: 1001;\n}\n\n.floating-bonus-indicator::before {\n  top: -10px;\n  left: -10px;\n  animation-delay: 0s;\n}\n\n.floating-bonus-indicator::after {\n  bottom: -10px;\n  right: -10px;\n  animation-delay: 0.25s;\n}\n\n@keyframes gradient-shift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes sparkle {\n  0% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n\n@keyframes float-down-fade-right {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) scale(0.8);\n  }\n  15% {\n    opacity: 1;\n    transform: translateY(-50%) scale(1);\n  }\n  85% {\n    opacity: 1;\n    transform: translateY(50vh) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(70vh) scale(0.8);\n  }\n}\n\n/* Progress Bar Styles */\n.progress-container { \n  width: 100%; \n  background: #e5e7eb; \n  border-radius: 4px; \n  margin: 1.5rem 0 2rem 0; \n  height: 8px; \n  overflow: hidden; \n}\n.progress-bar { \n  height: 100%; \n  background: #2563eb; \n  border-radius: 4px; \n  transition: width 0.3s; \n}\n\n/* Question Styles */\n.question-container {\n  text-align: center;\n  margin-bottom: 2rem;\n  min-height: 40px; \n}\n\n.question {\n  display: inline-block;\n  position: relative;\n  font-size: 1.3rem;\n  font-weight: 500;\n}\n\n/* Flag Options Styles */\n.flag-options { \n  display: flex; \n  flex-direction: column; \n  gap: 1rem; \n}\n.flag-option { \n  display: flex; \n  flex-direction: column; \n  align-items: center; \n  cursor: pointer; \n  transition: transform 0.15s; \n  position: relative; \n  background: #fff; \n  border-radius: 10px; \n  box-shadow: 0 1px 6px rgba(0,0,0,0.06); \n  padding: 0.7rem 0.7rem 0.3rem 0.7rem; \n  border: 1.5px solid transparent; \n}\n.flag-option:hover { \n  transform: translateY(-4px) scale(1.04); \n  box-shadow: 0 4px 16px rgba(37,99,235,0.08); \n}\n\n.flag-img { \n  width: 90px; \n  height: 60px; \n  object-fit: cover; \n  border-radius: 6px; \n  border: 2.5px solid transparent; \n  background: #eee; \n  transition: border-color 0.2s, box-shadow 0.2s; \n}\n.flag-img.correct { \n  border-color: #22c55e; \n  box-shadow: 0 0 0 4px #22c55e33; \n  animation: pulse-success 0.7s; \n}\n.flag-img.incorrect { \n  border-color: #ef4444; \n  animation: shake 0.5s; \n}\n\n/* Feedback Styles */\n.feedback { \n  margin: 1.5rem 0 0.5rem 0; \n  text-align: center; \n  font-size: 1.2rem; \n  font-weight: 600; \n  min-height: 2rem; \n  color: #1e40af; \n}\n\n/* Button Styles */\n.button {\n  background: #2563eb;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  margin: 8px;\n  min-width: 120px;\n}\n\n.button:hover {\n  background: #1d4ed8;\n}\n\n.button:active {\n  background: #1e40af;\n}\n\n.button.success {\n  background: #059669;\n}\n\n.button.success:hover {\n  background: #047857;\n}\n\n.button.secondary {\n  background: #6b7280;\n}\n\n.button.secondary:hover {\n  background: #4b5563;\n}\n\n/* Difficulty Buttons Styles */\n.difficulty-btn {\n  padding: 0.5rem 1.2rem;\nmargin-bottom: 1.5rem;\nmargin-right: 0.5rem;\nmargin-left: 0.5rem;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 1rem;\n  color: #222;\n  transition: background 0.15s, color 0.15s;\n}\n\n.difficulty-btn.active {\n  background: #2563eb;\n  color: #fff;\n}\n\n/* Modal Overlay - Simplified and Fixed */\n.modal { \n  position: fixed; \n  top: 0; \n  left: 0; \n  width: 100vw; \n  height: 100vh; \n  background: rgba(30, 41, 59, 0.5);\n  display: flex; \n  align-items: center; \n  justify-content: center; \n  z-index: 9999; \n  opacity: 0; \n  visibility: hidden; \n  transition: opacity 0.3s, visibility 0.3s; \n  overflow-y: auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.modal.active { \n  opacity: 1; \n  visibility: visible; \n}\n\n/* Modal Content - Unified for all platforms */\n.modal-content {\n  background: #f9fafb;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(30, 41, 59, 0.18);\n  border: 1px solid #e5e7eb;\n  animation: modal-fade-in 0.4s cubic-bezier(.4,0,.2,1);\n  font-family: 'Inter', Arial, sans-serif;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Native app specific adjustments */\n.modal.native-app {\n  background: rgba(0, 0, 0, 0.6);\n  padding: 10px;\n}\n\n.modal-content.native-content {\n  max-width: 95%;\n  max-height: 85vh;\n}\n\n@keyframes modal-fade-in {\n  from { opacity: 0; transform: translateY(32px) scale(0.98);}\n  to { opacity: 1; transform: translateY(0) scale(1);}\n}\n\n/* Modal Header */\n.modal-header { \n  display: flex; \n  justify-content: space-between; \n  align-items: center; \n  padding: 1.5rem 1.5rem 1rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.modal-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n/* Modal Body - Scrollable content area */\n.modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 1.5rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Close Button - Enhanced for mobile */\n.modal-close { \n  background: none; \n  border: none; \n  font-size: 2rem; \n  cursor: pointer; \n  color: #64748b;\n  transition: all 0.2s;\n  border-radius: 50%;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.modal-close:hover,\n.modal-close:focus {\n  background: #e0e7ef;\n  color: #1e293b;\n}\n\n.modal-close:active {\n  transform: scale(0.95);\n  background: #d1d5db;\n}\n\n/* High Score Note */\n.high-score-note {\n  margin: 1rem 0;\n  font-size: 0.9rem;\n  font-style: italic;\n  color: #666;\n  text-align: center;\n}\n\n/* High Scores Container */\n.high-scores-container {\n  padding: 1rem 0;\n}\n\n/* High Scores Difficulty Groups */\n.high-scores-difficulty-group {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e0e7ef;\n}\n\n.high-scores-difficulty-group:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.difficulty-group-header {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 1rem;\n}\n\n/* High Scores Header */\n.high-scores-header {\n  display: flex;\n  padding: 0.75rem 0 0.5rem 0;\n  border-bottom: 2px solid #e5e7eb;\n  font-weight: 600;\n  color: #4b5563;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n/* High Scores List */\n.high-scores-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.high-score-entry {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 0;\n  font-size: 0.95rem;\n  color: #4b5563;\n  border-bottom: 1px dashed #f3f4f6;\n}\n\n.high-score-entry:last-child {\n  border-bottom: none;\n}\n\n/* Column Layout */\n.header-rank, .entry-position {\n  flex: 0 0 15%;\n  text-align: center;\n}\n\n.header-name, .entry-name {\n  flex: 1;\n  text-align: left;\n  padding-right: 1rem;\n  overflow-wrap: break-word;\n}\n\n.header-score, .entry-points {\n  flex: 0 0 18%;\n  text-align: center;\n}\n\n.header-accuracy, .entry-accuracy {\n  flex: 0 0 20%;\n  text-align: center;\n}\n\n.header-date, .entry-date {\n  flex: 0 0 22%;\n  text-align: center;\n}\n\n/* Modal States */\n.modal-loading,\n.modal-empty {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n  font-style: italic;\n}\n\n.modal-loading {\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n.modal-empty {\n  background: #f0f9ff;\n  border: 1px dashed #bae6fd;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n/* Modal Footer */\n.modal-footer {\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\n  border-top: 1px solid #e0e7ef;\n  background: #f9fafb;\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.modal-footer .button {\n  min-height: 44px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n  transition: all 0.2s;\n}\n\n.modal-footer .button:active {\n  transform: scale(0.98);\n}\n\n/* Game Over Flag Display Styles */\n.game-over-flags-container {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.flag-column {\n  text-align: center;\n}\n\n.flag-column h3 {\n  margin-bottom: 1rem;\n}\n\n.flag-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.flag-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.flag-item img {\n  width: 120px;\n  height: 80px;\n  object-fit: contain;\n  border-radius: 6px;\n}\n\n.flag-item span {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  color: #6b7280;\n}\n\n.empty-message {\n  color: #6b7280;\n}\n\n/* Difficulty Selector */\n.difficulty-selector {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n/* Centered Text Style */\n.centered-text {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n/* Toggle Switch */\n.toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin: 1rem 0;\n}\n\n.toggle-switch {\n  position: relative;\n  width: 40px;\n  height: 20px;\n  display: inline-block;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switch-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #e5e7eb;\n  border-radius: 20px;\n  transition: background-color 0.3s;\n}\n\n.switch-slider::before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: #fff;\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggle-switch input:checked + .switch-slider {\n  background-color: #2563eb;\n}\n\n.toggle-switch input:checked + .switch-slider::before {\n  transform: translateX(20px);\n}\n\n.toggle-label {\n  font-size: 1rem;\n  color: #222;\n}\n\n/* Rotates emoji 45 degrees. Using this to turn a black square into a black diamond. */\n.rotate-emoji {\n  display: inline-block;\n  transform: rotate(45deg);\n  font-size: 1.25rem;\n}\n\n/* New High Score Banner */\n.new-high-score-banner {\n  background: linear-gradient(45deg, #ffd700, #ffed4e);\n  color: #1a1a1a;\n  text-align: center;\n  padding: 15px;\n  margin: 20px 0;\n  border-radius: 10px;\n  font-size: 1.5rem;\n  font-weight: bold;\n  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);\n  position: relative;\n  animation: celebrateGlowBounce 2s ease-in-out infinite;\n}\n\n.new-high-score-banner::after {\n  content: \"✨\";\n  font-size: 3rem;\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  animation: sparkle 1s ease-in-out infinite alternate;\n}\n\n.new-high-score-banner span {\n  display: inline-block;\n  animation: textPop 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes celebrateGlowBounce {\n  0%, 100% {\n    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);\n    transform: scale(1) translateY(0);\n  }\n  50% {\n    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.6);\n    transform: scale(1.02) translateY(-8px);\n  }\n}\n\n@keyframes textPop {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.1);\n  }\n}\n\n/* Leaderboard Banner */\n.leaderboard-banner {\n  background: linear-gradient(45deg, #f3f4f6, #e5e7eb);\n  color: #374151;\n  text-align: center;\n  padding: 15px;\n  margin: 20px 0;\n  border-radius: 10px;\n  font-size: 1.3rem;\n  font-weight: bold;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  position: relative;\n  animation: leaderboardGlow 2s ease-in-out infinite;\n  border: 2px solid #d1d5db;\n}\n\n.leaderboard-banner::after {\n  content: \"🏆\";\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  animation: trophyBounce 1.5s ease-in-out infinite alternate;\n}\n\n.leaderboard-banner span {\n  display: inline-block;\n  animation: subtleTextPop 0.8s ease-in-out infinite alternate;\n}\n\n@keyframes leaderboardGlow {\n  0%, 100% {\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    transform: scale(1) translateY(0);\n  }\n  50% {\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n    transform: scale(1.01) translateY(-4px);\n  }\n}\n\n@keyframes trophyBounce {\n  0% {\n    opacity: 0.6;\n    transform: scale(0.9) rotate(-5deg);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1.1) rotate(5deg);\n  }\n}\n\n@keyframes subtleTextPop {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.05);\n  }\n}\n\n/* Tooltip Styles */\n.tooltip-icon {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background: #ddd;\n  color: #333;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 8px;\n  cursor: pointer;\n  position: relative;\n  vertical-align: super;\n}\n\n.tooltip-text {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: #333;\n  color: #fff;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  min-width: 200px;\n  max-width: 300px;\n  z-index: 1000;\n  white-space: normal;\n  word-wrap: break-word;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border: 1px solid #555;\n}\n\n/* Mobile responsive tooltip adjustments */\n@media (max-width: 768px) {\n  .tooltip-text {\n    position: fixed;\n    left: 50% !important;\n    top: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    width: 90vw;\n    max-width: 350px;\n    min-width: auto;\n    font-size: 16px;\n    padding: 16px;\n    border-radius: 12px;\n    z-index: 10000;\n  }\n\n  .tooltip-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n\n/* Player Name Form */\n.player-name-form {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.player-name-input {\n  padding: 0.8rem 1.5rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 1.5rem;\n  width: 200px;\n  margin-right: 0.5rem;\n}\n\n.submit-button {\n  background: #2563eb; \n  color: #fff; \n  border: none; \n  padding: 0.8rem 1.5rem; \n  font-size: 1rem; \n  border-radius: 6px; \n  cursor: pointer; \n  transition: background 0.18s; \n  font-weight: 600; \n  box-shadow: 0 1px 4px rgba(0,0,0,0.04); \n  margin-bottom: 0.5rem;\n  margin-top: 1.5rem;\n  margin-right: 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.submit-button:hover {\n  background-color: #1e40af;\n}\n\n\n\n/* Info Button (replaces tooltip icon) */\n.info-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background: #ddd;\n  color: #333;\n  border: none;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  font-size: 14px;\n  line-height: 20px;\n  margin-left: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: bold;\n}\n\n.info-button:hover {\n  background: #bbb;\n  transform: scale(1.1);\n}\n\n.info-button:active {\n  transform: scale(0.95);\n}\n\n/* Info Modal Styles */\n.info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.info-modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modal-fade-in 0.3s ease-out;\n}\n\n.info-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.5rem 1rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.info-modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #1e293b;\n}\n\n.info-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #64748b;\n  padding: 4px;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.info-modal-close:hover {\n  background: #e0e7ef;\n  color: #1e293b;\n}\n\n.info-modal-body {\n  padding: 1.5rem;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.info-modal-body p {\n  margin: 0 0 1rem 0;\n  line-height: 1.6;\n  color: #374151;\n}\n\n.info-modal-body p:last-child {\n  margin-bottom: 0;\n}\n\n.info-modal-footer {\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Privacy Policy Modal Styles */\n.privacy-policy-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.privacy-policy-content {\n  background: white;\n  border-radius: 12px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n}\n\n.privacy-policy-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n}\n\n.privacy-policy-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #1f2937;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.2s;\n}\n\n.close-button:hover {\n  color: #374151;\n}\n\n.privacy-policy-body {\n  padding: 24px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.privacy-policy-body h3 {\n  color: #1f2937;\n  margin-top: 24px;\n  margin-bottom: 12px;\n  font-size: 1.25rem;\n}\n\n.privacy-policy-body h4 {\n  color: #374151;\n  margin-top: 20px;\n  margin-bottom: 8px;\n  font-size: 1.1rem;\n}\n\n.privacy-policy-body h5 {\n  color: #4b5563;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  font-size: 1rem;\n}\n\n.privacy-policy-body p {\n  margin-bottom: 12px;\n  line-height: 1.6;\n  color: #4b5563;\n}\n\n.privacy-policy-body ul {\n  margin-bottom: 16px;\n  padding-left: 20px;\n}\n\n.privacy-policy-body li {\n  margin-bottom: 6px;\n  line-height: 1.5;\n  color: #4b5563;\n}\n\n.privacy-policy-body a {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.privacy-policy-body a:hover {\n  text-decoration: underline;\n}\n\n.privacy-policy-footer {\n  padding: 16px 24px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Web Availability Text - Only shown in native app, positioned at bottom left */\n.web-availability-text {\n  position: fixed;\n  bottom: 50px;\n  left: 20px;\n  background: #ffffff;\n  color: #000;\n  border: 1px solid #d1d5db;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: normal;\n  white-space: nowrap;\n  z-index: 100;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Web Availability Button - Clickable styling */\n.web-availability-button {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.web-availability-button:hover {\n  background: #f3f4f6;\n}\n\n/* Privacy Policy Button - Small and Subtle */\n.privacy-policy-button {\n  position: fixed;\n  bottom: 50px;\n  right: 20px;\n  background: #f3f4f6;\n  color: #000;\n  border: 1px solid #d1d5db;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: normal;\n  transition: background-color 0.2s;\n  z-index: 100;\n  min-width: auto;\n  margin: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.privacy-policy-button:hover {\n  background: #e5e7eb;\n}\n\n/* Native app adjustments for positioning */\n.native-app .web-availability-text {\n  bottom: 60px;\n  left: 30px;\n}\n\n.native-app .privacy-policy-button {\n  bottom: 60px;\n  right: 30px;\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .web-availability-text {\n    bottom: 45px;\n    left: 15px;\n    font-size: 11px;\n    padding: 6px 10px;\n  }\n  \n  .privacy-policy-button {\n    bottom: 45px;\n    right: 15px;\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 480px) {\n  .web-availability-text {\n    bottom: 40px;\n    left: 10px;\n    font-size: 10px;\n    padding: 5px 8px;\n  }\n  \n  .privacy-policy-button {\n    bottom: 40px;\n    right: 10px;\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n}\n\n/* High Scores Tabs */\n.high-scores-tabs {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n  padding: 0;\n  margin: 0;\n}\n\n.tab-button {\n  flex: 1;\n  padding: 1rem 1.5rem;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #6b7280;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.tab-button:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.tab-button.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  background: #eff6ff;\n}\n\n.tab-button.active:hover {\n  background: #dbeafe;\n}\n\n/* Mobile responsive tabs */\n@media (max-width: 768px) {\n  .tab-button {\n    padding: 0.75rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Native app adjustments for tabs */\n.native-app .high-scores-tabs {\n  border-bottom: 1px solid #d1d5db;\n}\n\n.native-app .tab-button {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Personal Best Banner */\n.personal-best-banner {\n  background: linear-gradient(45deg, #ffd700, #ffed4e);\n  color: #1a1a1a;\n  text-align: center;\n  padding: 15px;\n  margin: 20px 0;\n  border-radius: 10px;\n  font-size: 1.5rem;\n  font-weight: bold;\n  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);\n  position: relative;\n  animation: celebrateGlowBounce 2s ease-in-out infinite;\n}\n\n.personal-best-banner::after {\n  content: \"✨\";\n  font-size: 3rem;\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  animation: sparkle 1s ease-in-out infinite alternate;\n}\n\n.personal-best-banner span {\n  display: inline-block;\n  animation: textPop 0.5s ease-in-out infinite alternate;\n}\n\n/* Personal Best Banner Styles for 2nd, 3rd, 4th place - gray like leaderboard */\n.personal-best-banner.secondary {\n  background: linear-gradient(45deg, #f3f4f6, #e5e7eb);\n  color: #374151;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  animation: leaderboardGlow 2s ease-in-out infinite;\n  border: 2px solid #d1d5db;\n}\n\n.personal-best-banner.secondary::after {\n  content: \"✨\";\n  font-size: 3rem;\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  animation: sparkle 1s ease-in-out infinite alternate;\n}\n\n.personal-best-banner.secondary span {\n  animation: subtleTextPop 0.8s ease-in-out infinite alternate;\n}\n\n/* Info Modal Styles */\n.info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Confirmation Dialog Styles */\n.confirmation-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.confirmation-dialog {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.confirmation-dialog h3 {\n  margin: 0 0 16px 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.confirmation-dialog p {\n  margin: 0 0 24px 0;\n  color: #4b5563;\n  line-height: 1.5;\n  font-size: 1rem;\n}\n\n.confirmation-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.confirmation-buttons .button {\n  min-width: 120px;\n  padding: 10px 16px;\n  font-size: 0.9rem;\n}\n\n.confirmation-buttons .button.secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.confirmation-buttons .button.secondary:hover {\n  background: #4b5563;\n}\n\n/* Mobile responsiveness for confirmation dialog */\n@media (max-width: 480px) {\n  .confirmation-dialog {\n    margin: 20px;\n    padding: 20px;\n  }\n  \n  .confirmation-buttons {\n    flex-direction: column;\n  }\n  \n  .confirmation-buttons .button {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* Data Disclosure Modal Styles */\n.data-disclosure-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  z-index: 10002;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.data-disclosure-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.data-disclosure-modal h3 {\n  margin: 0 0 16px 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.data-disclosure-modal p {\n  margin: 0 0 24px 0;\n  color: #4b5563;\n  line-height: 1.5;\n  font-size: 1rem;\n}\n\n.data-disclosure-modal .button {\n  min-width: 120px;\n  padding: 10px 24px;\n  font-size: 1rem;\n}\n\n.data-disclosure-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.data-disclosure-buttons .button {\n  min-width: 120px;\n  padding: 10px 16px;\n  font-size: 0.9rem;\n}\n\n.data-disclosure-buttons .button.secondary {\n  background: #f3f4f6;\n  color: #000000;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.data-disclosure-buttons .button.secondary:hover {\n  background: #e5e7eb;\n}\n\n.data-disclosure-buttons .button.success {\n  background: #2563eb;\n}\n\n/* Mobile responsiveness for data disclosure modal */\n@media (max-width: 480px) {\n  .data-disclosure-modal {\n    margin: 20px;\n    padding: 20px;\n  }\n  \n  .data-disclosure-buttons {\n    flex-direction: column;\n  }\n  \n  .data-disclosure-buttons .button {\n    width: 100%;\n    min-width: auto;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
